import { render } from "./ButtonBlue.vue?vue&type=template&id=ec12157c&scoped=true"
import script from "./ButtonBlue.vue?vue&type=script&lang=js"
export * from "./ButtonBlue.vue?vue&type=script&lang=js"

import "./ButtonBlue.vue?vue&type=style&index=0&id=ec12157c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec12157c"]])

export default __exports__